<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/kaisu/mrp/page"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('MRPdanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao')">
            <el-input v-model="yt.conditions.planNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple  :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('MRPzhuangtai')">
            <yi_dictionary_select :max="999" multiple clearable="false"  :type="'KAISU_MRP_HEAD_STATUS'" :ids.sync="yt.conditions.statusList">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear()">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button :loading="loading" size="mini" @click="getSync" type="primary">
          {{$t('huoquMRPshuju')}}
        </el-button>
<!--        <el-button size="mini" @click="resetDictionaries" plain>-->
<!--          {{$t('chongzhizidian')}}-->
<!--        </el-button>-->
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
        </el-button>
      </template> -->
      <!-- 自定义某个字段 -->

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status==0">
            <el-button v-if="utils.checkPower('web_wms_mrp_calculate_button')" type="text" @click="shortage(scope.row)">{{$t('queliaojisuan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_wms_mrp_details_button')"  type="text" @click="yt.showEditDialog('mingxi', scope.row,'80%')">{{$t('mingxi')}}
            </el-button>
          </el-col>
<!--          <el-col :span="0.1">-->
<!--            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}-->
<!--            </el-button>-->
<!--          </el-col>-->
          <el-col :span="0.1" v-if="scope.row.status==0">
            <el-button v-if="utils.checkPower('web_wms_mrp_delete_button')" type="text" class="font-color-danger"
                @click="yt.remove(scope.row,'/custom/kaisu/mrp/delete')">
              {{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId">
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <!-- <el-input v-model="yt.editObj.priority" maxlength="8" ></el-input> -->
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionary/item/create')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!--缺料计算-->
      <template v-if="yt.editObj.action == 'queliaojisuan'">
        <div class="dialog-scroller">
          <shortage_calculation  ref="calculationOrder" :calculation="yt.editObj"></shortage_calculation>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="saveCalculationLoading"  size="mini" @click="saveCalculation"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!--明细-->
      <template v-if="yt.editObj.action == 'mingxi'">
        <div class="dialog-scroller">
          <mrp_details :mrpOrder="yt.editObj"></mrp_details>
        </div>
      </template>
      <!-- 编辑表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId" disabled>
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST','/web/config/customer/dictionary/item/update')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import mrp_details from '@@/pages/web/wms/mrp/mrp_details/index'
import shortage_calculation from '@@/pages/web/wms/mrp/mrp_details/shortage_calculation'
export default {
  name: 'web_wms_mrp_list',
  components: {
    mrp_details,
    shortage_calculation
  },
  data() {
    return {
      loading:false,
      saveCalculationLoading:false,
      calculationId:null,
      dictionaryList: [],
      list: [],
      rolesList: [],
      organizationList: [],
      columns: [{
        label: 'MRPdanhao',
        prop: 'no',
      }, {
        label: 'jihuadanhao',
        prop: 'planNo',
      }, {
        label: 'chanpinbianma',
        prop: 'material.code',
      }, {
        label: 'chanpinmingcheng',
        prop: 'material.name',
      }, {
        label: 'jihuashuliang',
        prop: 'planQuantity',
      },
        {
          label: 'MRPzhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'KAISU_MRP_HEAD_STATUS',
        },
        {
        label: 'chuangjianshijian',
        prop: 'createTime',
        type: 'time',
      },{
        label: 'caozuo',
        type: 'slot',
        width: 230,
        fixed: 'right'
      }]
    };
  },
  watch:{
    "yt.isShowEditDialog":{
      handler(n) {
        if(this.yt.editObj.action=='mingxi'&&n==false){
          this.yt.get(1);
        }
      },
      immediate: false,
      deep: true
    },
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.yt.conditions = {
        //表格默认按照创建时间降序排序。
        orderBy: 'createTime desc',
      }
    }, 300)
  },

  methods: {
    getSync(){
      this.loading=true
      return this.http.post('/custom/kaisu/mrp/sync').then(response => {
        this.yt.get(1)
        this.utils.successMessage(this.$t(response.msg));
        this.loading=false
      }).catch(error => {
        this.$message.error(error)
        this.loading=false
      })
    },
    shortage(row){
      this.yt.showEditDialog('queliaojisuan', row,'80%')
      this.calculationId = row.id
    },
    saveCalculation(){
      this.saveCalculationLoading = true
      let ids = this.$refs['calculationOrder'].ids
      if (ids !== null) {
        let params = {
          warehouseIds: ids,
          id:this.calculationId
        }
        return this.http.post('/custom/kaisu/mrp/shortageCalc', params).then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1)
          this.saveCalculationLoading = false
        }).catch(error => {
          this.$message.error(error)
          this.saveCalculationLoading = false
        })
      }else {
        this.$message.error(this.$t('qinggouxuanshuju'))
      }
    },
  }
};
</script>
